module.exports = __webpack_public_path__ + "media/lookbook_0.a5a08ddd.webm";